export default "<iframe :id=id ref=\"iframe\"></iframe>\n";